<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <EditUser />
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-12">
          <projects-table />
        </div>
      </div> -->
    </div>
  </template>
  
  <script>
  import EditUser from "./components/EditUser";
  // import ProjectsTable from "./components/ProjectsTable";
  
  export default {
    name: "Users",
    components: {
      EditUser,
      // ProjectsTable,
    },
  };
  </script>
  